import { jsx } from "react/jsx-runtime";
const Menu = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: props.color,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "prefix__feather prefix__feather-menu",
      ...props,
      children: /* @__PURE__ */ jsx("path", { d: "M3 12h18M3 6h18M3 18h18" })
    }
  );
};
export {
  Menu as default
};
